export const ExceptionDetailsSaia = ({ classes, exceptionDetails }) => {
  return (
    <div className={classes.valueContainer}>
      <span className={classes.label}>ADE Number</span>
      <span className={`${classes.value} ${classes.valueHighlighted}`}>
        {exceptionDetails.adeNumber}
      </span>
    </div>
  );
};
